var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

// lib/tiltify.ts
import { default as axios } from "axios";

// lib/const.ts
var DEV_TOKEN_URL = `https://qo76bga8l7.execute-api.us-east-1.amazonaws.com/api/tiltify/token/`;
var QA_TOKEN_URL = `https://zrrgl95ql6.execute-api.us-east-1.amazonaws.com/api/tiltify/token/`;
var PROD_TOKEN_URL = `https://gr3holprdf.execute-api.us-east-1.amazonaws.com/api/tiltify/token/`;
var PROXY_URL = "https://gshso0nx9d.execute-api.us-east-1.amazonaws.com/api/";
var BASE_URL = "https://v5api.tiltify.com/api/";
var SJ_CAUSE_ID = "400f5687-6017-4d1a-a4d9-7c9166b984c2";

// lib/tiltify.types.ts
var TILTIFY_FITNESS_GOAL_TYPES = [
  "Cycling",
  "Dancing",
  "Other",
  "Rowing",
  "Running",
  "Swimming",
  "Walking",
  "Workout"
];

// lib/tiltify.ts
var TILTIFY_AUTH_MODE = /* @__PURE__ */ ((TILTIFY_AUTH_MODE2) => {
  TILTIFY_AUTH_MODE2[TILTIFY_AUTH_MODE2["DISABLED"] = -1] = "DISABLED";
  TILTIFY_AUTH_MODE2[TILTIFY_AUTH_MODE2["CLIENT"] = 0] = "CLIENT";
  TILTIFY_AUTH_MODE2[TILTIFY_AUTH_MODE2["USER"] = 1] = "USER";
  return TILTIFY_AUTH_MODE2;
})(TILTIFY_AUTH_MODE || {});
var TILTIFY_AUTH_STATUS = /* @__PURE__ */ ((TILTIFY_AUTH_STATUS2) => {
  TILTIFY_AUTH_STATUS2[TILTIFY_AUTH_STATUS2["MISSING"] = 0] = "MISSING";
  TILTIFY_AUTH_STATUS2[TILTIFY_AUTH_STATUS2["VALID"] = 1] = "VALID";
  TILTIFY_AUTH_STATUS2[TILTIFY_AUTH_STATUS2["NEEDS_REFRESH"] = 2] = "NEEDS_REFRESH";
  TILTIFY_AUTH_STATUS2[TILTIFY_AUTH_STATUS2["NEW_AUTH"] = 3] = "NEW_AUTH";
  TILTIFY_AUTH_STATUS2[TILTIFY_AUTH_STATUS2["FAILED_AUTH"] = -1] = "FAILED_AUTH";
  TILTIFY_AUTH_STATUS2[TILTIFY_AUTH_STATUS2["ERASED_AUTH"] = 4] = "ERASED_AUTH";
  return TILTIFY_AUTH_STATUS2;
})(TILTIFY_AUTH_STATUS || {});
var _TiltifyLibError = class _TiltifyLibError extends Error {
  constructor(msg) {
    super(msg);
    __publicField(this, "cursor", null);
    __publicField(this, "max");
    __publicField(this, "endpoint");
    Object.setPrototypeOf(this, _TiltifyLibError.prototype);
  }
};
__name(_TiltifyLibError, "TiltifyLibError");
var TiltifyLibError = _TiltifyLibError;
var _Tiltify = class _Tiltify {
  constructor({
    timeout = 5e3,
    maxRedirects = 10,
    maxContentLength = 50 * 1e3 * 1e3
  } = {
    timeout: 5e3,
    maxRedirects: 10,
    maxContentLength: 50 * 1e3 * 1e3
  }) {
    __publicField(this, "_authCallback", /* @__PURE__ */ __name(() => {
    }, "_authCallback"));
    __publicField(this, "_authData", null);
    __publicField(this, "_tokenExpiration", 0);
    __publicField(this, "_tokenURL", "");
    __publicField(this, "_refreshToken", null);
    __publicField(this, "_token", null);
    __publicField(this, "_apiMode", "public");
    __publicField(this, "_authMode", 0 /* CLIENT */);
    __publicField(this, "_baseURL", BASE_URL);
    __publicField(this, "_axiosInstance");
    this._axiosInstance = axios.create({
      //5 sec timeout
      timeout,
      //follow up to 10 HTTP 3xx redirects
      maxRedirects,
      //cap the maximum content length we'll accept to 50MBs, just in case
      maxContentLength
    });
  }
  static get Instance() {
    return this._instance || (this._instance = new this());
  }
  SetPublicMode() {
    this._apiMode = "public";
  }
  SetCauseMode() {
    this._apiMode = "cause";
  }
  GetMode() {
    return this._apiMode;
  }
  DisableAuth() {
    this._authMode = -1 /* DISABLED */;
  }
  UseClientAuth() {
    this._authMode = 0 /* CLIENT */;
  }
  UseUserAuth(authEnvironment = "prod") {
    this._authMode = 1 /* USER */;
    switch (authEnvironment) {
      case "dev":
        this._tokenURL = DEV_TOKEN_URL;
        break;
      case "prod":
        this._tokenURL = PROD_TOKEN_URL;
        break;
      case "qa":
        this._tokenURL = QA_TOKEN_URL;
        break;
    }
  }
  GetAuthMode() {
    return this._authMode;
  }
  GetAuthModeAsString() {
    return this._authMode.toString();
  }
  GetAuthStatus() {
    if (!this._authData) {
      return 0 /* MISSING */;
    }
    if (this._tokenExpiration <= Date.now()) {
      return 2 /* NEEDS_REFRESH */;
    }
    return 1 /* VALID */;
  }
  GetTokenURL() {
    return this._tokenURL;
  }
  TestAuthCallback() {
    this._authCallback({ status: 0 /* MISSING */ });
  }
  TestClearAuthData() {
    this.SetAuthData(null);
  }
  TestSetAuthData() {
    this.SetAuthData({
      access_token: "a",
      created_at: (/* @__PURE__ */ new Date()).toISOString(),
      expires_in: Date.now() + 1e3,
      refresh_token: "r"
    });
  }
  TestOverrideTokenExpiration(expiration) {
    this._tokenExpiration = expiration;
  }
  /**
   *
   * @param {string} token
   * @param {number} expiration Date() compatible milliseconds
   * @param {string|null} refresh
   */
  OverrideAuthToken(token, expiration, refresh = null) {
    this._token = token;
    this._tokenExpiration = expiration;
    this._refreshToken = refresh;
  }
  GetTokenExpiration() {
    return this._tokenExpiration;
  }
  GetCurrentRefreshToken() {
    return this._refreshToken;
  }
  GetCurrentToken() {
    return this._token;
  }
  /**
   * Sets the auth callback to use for Auth Updates. Calling this multiple time will replace the current callback.
   * @param {Function} callback
   */
  RegisterAuthCallback(callback) {
    this._authCallback = callback;
  }
  /**
   * Removes the current callback from Auth Updates
   */
  UnregisterAuthCallback() {
    this._authCallback = () => {
    };
  }
  /**
   * For usage with a tiltify proxy, disables AuthToken and overrides V5 URL.
   * @param {string} baseURL  The base URL to use instead of tiltify
   */
  UseProxy(baseURL = PROXY_URL) {
    if (this._authMode !== 1 /* USER */) {
      this.DisableAuth();
    }
    this.OverrideBaseURL(baseURL);
  }
  OverrideBaseURL(url) {
    this._baseURL = url;
  }
  CurrentBaseURL() {
    return this._baseURL;
  }
  UseOriginalBaseURL() {
    this._baseURL = BASE_URL;
  }
  /**
   * Just waits asynchronously for the given time. Useful for Tiltify timeouts
   * @param {number} seconds
   * @returns
   */
  WaitForSeconds(seconds) {
    return new Promise((resolve) => {
      setTimeout(resolve, seconds * 1e3);
    });
  }
  SetAuthData(data) {
    this._authData = data;
    if (!data) {
      this._token = null;
      this._tokenExpiration = 0;
      this._refreshToken = null;
      this._authCallback({ status: 4 /* ERASED_AUTH */ });
      return;
    }
    this._token = "Bearer " + data.access_token;
    this._tokenExpiration = Date.parse(data.created_at) + 1e3 * data.expires_in;
    if (data.refresh_token) {
      this._refreshToken = data.refresh_token;
    }
    this._authCallback({
      status: 3 /* NEW_AUTH */,
      authData: data
    });
  }
  CheckClientIDSecret() {
    let errMsg = "";
    if (!process.env.TILTIFY_CLIENT_ID || process.env.TILTIFY_CLIENT_ID.length === 0) {
      errMsg += "process.env.TILTIFY_CLIENT_ID is missing! ";
    }
    if (!process.env.TILTIFY_SECRET || process.env.TILTIFY_SECRET.length === 0) {
      errMsg += "process.env.TILTIFY_SECRET is missing!";
    }
    if (errMsg.length > 0) {
      throw new Error("GetAuthV5Token::" + errMsg);
    }
  }
  async GetAuthToken() {
    if (this._authMode === -1 /* DISABLED */) {
      return null;
    }
    if (Date.now() > this._tokenExpiration) {
      let config;
      if (this._authMode === 0 /* CLIENT */) {
        this.CheckClientIDSecret();
        config = {
          method: "post",
          url: "https://v5api.tiltify.com/oauth/token",
          data: {
            client_id: process.env.TILTIFY_CLIENT_ID,
            client_secret: process.env.TILTIFY_SECRET,
            grant_type: "client_credentials",
            scope: "cause"
          }
        };
      } else {
        config = {
          method: "post",
          url: this._tokenURL,
          data: {
            grant_type: "refresh_token",
            refresh_token: this._refreshToken
          }
        };
      }
      try {
        const resp = await this._axiosInstance(config);
        if (resp.data.error) {
          this._authCallback({
            status: -1 /* FAILED_AUTH */,
            authData: resp.data.error
          });
          this.SetAuthData(null);
          throw new Error(
            `${resp.data.error} : ${resp.data.error_description}`
          );
        } else {
          this.SetAuthData(resp.data);
        }
      } catch (e) {
        console.error("tiltify::GetAuth:", e.message);
        console.error(e);
        throw e;
      }
    }
    return this._token;
  }
  /**
   * Generic request to `https://v5api.tiltify.com/api/${endpoint}`
   * Will auto-retry 5 times on timeout or auth-fail
   */
  async PerformRequest(endpoint, method = "get", retry = 5) {
    const token = await this.GetAuthToken();
    let config = {
      method,
      url: `${this._baseURL}${endpoint}`,
      headers: {
        Authorization: token
      }
    };
    try {
      return await this._axiosInstance.request(config);
    } catch (error) {
      if (error.response || error.code) {
        if (retry > 0) {
          if (error.code === "ECONNABORTED" || error.response && (error.response.status === 401 || error.response.code === "ECONNABORTED" || error.response.status === 502)) {
            await this.WaitForSeconds(0.5);
            return await this.PerformRequest(endpoint, method, retry - 1);
          }
        } else {
          console.error("Request V5:: Retried 5 times!");
        }
      }
      throw error;
    }
  }
  /**
   * Helper method for calling the V5 API. Tiltify error responses will be returned as data.
   */
  async GET(endpoint, limit = 100, cursor = null) {
    let res;
    const url = new URL(endpoint, "http://localhost");
    url.searchParams.append("limit", String(limit));
    if (cursor != null) {
      url.searchParams.append("after", cursor);
    }
    try {
      res = (await this.PerformRequest(url.pathname + url.search)).data;
    } catch (err) {
      if (err.response && err.response.data) {
        res = err.response.data;
      } else {
        throw err;
      }
    }
    return res;
  }
  /**
   * A DIY paginator. You provide an async callback, that will receive an array of data per page. Your callback must return a cursor to continue, or null to stop.
   * @param {string} endpoint
   * @param {dataCallback} dataCallback callback
   * @param {number} limit The amount of entries to grab at a time, defaults to 100.  Max value is 100.
   */
  async GET_Paginator(endpoint, dataCallback, limit = 100) {
    let cursor = null;
    do {
      const resp = await this.GET(endpoint, Math.min(limit, 100), cursor);
      if (resp.error) {
        throw new Error(
          JSON.stringify(resp.error) + endpoint + Math.min(limit, 100).toString() + cursor
        );
      }
      try {
        cursor = await dataCallback(resp.data, resp.metadata);
      } catch (err) {
        console.error("GET_Paginator::", endpoint, err);
      }
    } while (cursor !== null);
  }
  /**
   * A wrapper around GETV5 that handles paginating results via cursor.
   * @param {string} endpoint
   * @param {number} [max=Number.MAX_VALUE] The max size of the array returned.
   * @param {number} [batchLimit=100] The limit size to use when making requests. Generally you don't need to change this
   */
  async GET_Array(endpoint, max = Number.MAX_VALUE, batchLimit = 100) {
    let cursor = null;
    const data = [];
    do {
      const resp = await this.GET(
        endpoint,
        Math.min(batchLimit, max - data.length),
        cursor
      );
      if (resp.error) {
        const libError = new TiltifyLibError(resp.error.message);
        libError.cursor = cursor;
        libError.max = Math.min(batchLimit, max - data.length);
        libError.endpoint = `${this._baseURL}${endpoint}`;
        throw libError;
      }
      data.push(...resp.data);
      cursor = resp.metadata.after;
    } while (cursor != null && data.length < max);
    return data;
  }
  async tryCatchDataWrapper(promise) {
    try {
      const res = await promise;
      return res.data ?? null;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
  async notFoundDataWrapper(promise) {
    const res = await promise;
    if (res.error) {
      if (res.error.status === 404) {
        return null;
      }
      throw new Error(JSON.stringify(res.error));
    }
    return res.data;
  }
  /**
   * Gets the Campaign for the id. If supporting is set true, this will return the Supporting Campaign instead (if possible).
   */
  GetCampaign(campaignID, isTeam = false) {
    return this.tryCatchDataWrapper(
      this.GET(
        `${this._apiMode}/${isTeam ? "team_" : ""}campaigns/${campaignID}`
      )
    );
  }
  /**
   * Returns the campaign data or null
   */
  FindCampaign(userTeamSlug, campaignSlug, isTeam = false) {
    if (isTeam) {
      return this.notFoundDataWrapper(
        this.GET(
          `${this._apiMode}/team_campaigns/by/slugs/${userTeamSlug}/${campaignSlug}`
        )
      );
    } else {
      return this.notFoundDataWrapper(
        this.GET(
          `${this._apiMode}/campaigns/by/slugs/${userTeamSlug}/${campaignSlug}`
        )
      );
    }
  }
  /**
   * Returns the Team data or null
   */
  FindTeam(slug) {
    return this.notFoundDataWrapper(
      this.GET(`public/teams/by/slug/${slug}`)
    );
  }
  /**
   * Returns the User data or null
   */
  FindUser(slug) {
    return this.notFoundDataWrapper(
      this.GET(`public/users/by/slug/${slug}`)
    );
  }
  /**
   * Gets the User for the id.
   * @param {string} id
   */
  GetUser(id) {
    return this.tryCatchDataWrapper(
      this.GET(`${this._apiMode}/users/${id}`)
    );
  }
  /**
   * Gets the team for the team ID
   * @param teamID
   * @constructor
   */
  async GetTeam(teamID) {
    return this.notFoundDataWrapper(this.GET(`teams/${teamID}`));
  }
  /**
   * Gets a Fundraising Event by id
   * @param fundraiserID
   * @constructor
   */
  async GetFundraiser(fundraiserID) {
    return (await this.GET(
      `public/fundraising_events/${fundraiserID}`
    )).data;
  }
  /**
   * Gets all St. Jude Fundraising Events
   * @constructor
   */
  async GetCurrentEvents() {
    return await this.GET(
      `public/causes/${SJ_CAUSE_ID}/fundraising_events?limit=100`
    );
  }
  /**
   * Get a team campaign's supporting campaigns
   * @param teamCampaignID
   * @constructor
   */
  async GetTeamSupportingCampaigns(teamCampaignID) {
    return await this.GET_Array(
      `${this._apiMode}/team_campaigns/${teamCampaignID}/supporting_campaigns`
    );
  }
  /**
   * Gets the campaign for the team. If campaign is null, then all campaigns will be returned
   * @param teamSlugID
   * @param campaignSlugID
   * @constructor
   */
  async GetTeamCampaign(teamSlugID, campaignSlugID = null) {
    if (campaignSlugID === null) {
      return await this.GET(
        `teams/${teamSlugID}/campaigns`
      ).then((result) => result.data);
    }
    return await this.GET(
      `teams/${teamSlugID}/campaigns/${campaignSlugID}`
    ).then((result) => result.data);
  }
  /**
   * Get all campaigns for a team
   * @constructor
   */
  GetAllTeamCampaigns() {
    return this.GET_Array(`cause/team_campaigns`);
  }
  /**
   * Gets all campaigns for a User ID
   * @param userID
   * @constructor
   */
  GetUserCampaigns(userID) {
    return this.GET_Array(
      `public/users/${userID}/campaigns`
    );
  }
  /**
   * Gets all campaigns for a Team ID
   * @param teamID
   * @param status
   * @param supportingType
   * @constructor
   */
  GetTeamCampaigns(teamID, status, supportingType) {
    const searchParams = new URLSearchParams();
    if (status) {
      searchParams.append("status", status);
    }
    if (supportingType) {
      searchParams.append("supporting_type", supportingType);
    }
    let endpoint = `public/teams/${teamID}/team_campaigns`;
    if (searchParams.size > 0) {
      endpoint = `${endpoint}?${searchParams.toString()}`;
    }
    return this.GET_Array(endpoint);
  }
  /**
   * Returns a cause by its ID
   * @param causeID
   * @constructor
   */
  GetCause(causeID) {
    return this.notFoundDataWrapper(
      this.GET(`public/causes/${causeID}`)
    );
  }
  /**
   * Gets the targets for a given campaign ID
   * @param campaignID
   * @param isTeam
   * @constructor
   */
  async GetTargets(campaignID, isTeam = false) {
    return await this.GET_Array(
      `${this._apiMode}/${isTeam ? "team_" : ""}campaigns/${campaignID}/targets`
    );
  }
  /**
   * Gets the milestones for a given campaign ID
   * @param campaignID
   * @param isTeam
   * @constructor
   */
  async GetMilestones(campaignID, isTeam = false) {
    return await this.GET_Array(
      `${this._apiMode}/${isTeam ? "team_" : ""}campaigns/${campaignID}/milestones`
    );
  }
  /**
   * Gets the next milestone for a campaign
   * @param campaignID
   * @param isTeam
   * @param amountRaised
   * @constructor
   */
  async GetNextMilestone(campaignID, isTeam = false, amountRaised = null) {
    if (amountRaised === null) {
      const campaign = await this.GetCampaign(campaignID, isTeam);
      if (campaign) {
        amountRaised = Number(campaign.amount_raised?.value ?? 0);
      } else {
        return null;
      }
    }
    const milestones = (await this.GetMilestones(campaignID, isTeam)).filter((value) => {
      return value.amount && Number(value.amount.value) > amountRaised;
    }).sort((a, b) => {
      return Number(a.amount?.value ?? 0) - Number(b.amount?.value ?? 0);
    });
    if (milestones.length < 1) {
      return null;
    }
    return milestones[0];
  }
  /**
   * Gets the polls for a campaign
   * @param campaignID
   * @param isTeam
   * @constructor
   */
  async GetPolls(campaignID, isTeam = false) {
    return await this.GET_Array(
      `${this._apiMode}/${isTeam ? "team_" : ""}campaigns/${campaignID}/polls`
    );
  }
  /**
   * Gets a single poll for a campaign by ID
   * @param campaignID
   * @param pollID
   * @param isTeam
   * @constructor
   */
  async GetPoll(campaignID, pollID, isTeam = false) {
    return (await this.GET(
      `public/${isTeam ? "team_" : ""}campaigns/${campaignID}/polls/${pollID}`
    )).data ?? null;
  }
  /**
   * Gets the schedule for a given campaign
   * @param campaignID
   * @param isTeam
   * @constructor
   */
  async GetSchedule(campaignID, isTeam = false) {
    return await this.GET_Array(
      `${this._apiMode}/${isTeam ? "team_" : ""}campaigns/${campaignID}/schedules`
    );
  }
  /**
   * Gets the rewards for a given campaign
   * @param campaignID
   * @param isTeam
   * @constructor
   */
  async GetRewards(campaignID, isTeam = false) {
    return await this.GET_Array(
      `${this._apiMode}/${isTeam ? "team_" : ""}campaigns/${campaignID}/rewards`
    );
  }
  /**
   * Get donations for the given campaign
   * @param campaignID
   * @param isTeam
   * @param count
   * @param completed_before
   * @param completed_after
   * @constructor
   */
  async GetCampaignDonations(campaignID, isTeam = false, count = 10, completed_before = null, completed_after = null) {
    const sp = new URLSearchParams();
    if (completed_before) {
      if (typeof completed_before === "string") {
        sp.append("completed_before", completed_before);
      } else {
        sp.append("completed_before", completed_before.toISOString());
      }
    }
    if (completed_after) {
      if (typeof completed_after === "string") {
        sp.append("completed_after", completed_after);
      } else {
        sp.append("completed_after", completed_after.toISOString());
      }
    }
    return await this.GET_Array(
      `${this._apiMode}/${isTeam ? "team_" : ""}campaigns/${campaignID}/donations?${sp.toString()}`,
      count
    );
  }
  /**
   * Gets donations for the given cause
   * @param count
   * @param created_before
   * @param created_after
   * @constructor
   */
  GetCauseDonations(count = 10, created_before = null, created_after = null) {
    const sp = new URLSearchParams();
    if (created_before) {
      sp.append("created_before", created_before);
    }
    if (created_after) {
      sp.append("created_after", created_after);
    }
    if (sp.size > 0) {
      return this.GET_Array(
        `cause/donations?${sp.toString()}`,
        count
      );
    }
    return this.GET_Array(`cause/donations`, count);
  }
  /**
   * Gets the donor leaderboard for a given campaign ID
   * @param campaignID
   * @param timeType
   * @param isTeam
   * @param max
   * @constructor
   */
  GetLeaderboard(campaignID, timeType = "all", isTeam = false, max = Number.MAX_VALUE) {
    if (!["daily", "weekly", "monthly", "yearly", "ytd", "all"].includes(timeType)) {
      throw new Error(
        `tiltify-lib::GetLeaderboard: Invalid time_type! Must be one of "daily" | "weekly" | "monthly" | "yearly" | "ytd" | "all"`
      );
    }
    return this.GET_Array(
      `${this._apiMode}/${isTeam ? "team_" : ""}campaigns/${campaignID}/donor_leaderboard?time_type=${timeType}`,
      max
    );
  }
  /**
   * Gets the donor leaderboard for a given campaign ID with a cursor
   * @param campaignID
   * @param timeType
   * @param isTeam
   * @param max
   * @param cursor
   * @constructor
   */
  GetLeaderboardWithCursor(campaignID, timeType = "all", isTeam = false, max = Number.MAX_VALUE, cursor = null) {
    if (!["daily", "weekly", "monthly", "yearly", "ytd", "all"].includes(timeType)) {
      throw new Error(
        `tiltify-lib::GetLeaderboard: Invalid time_type! Must be one of "daily" | "weekly" | "monthly" | "yearly" | "ytd" | "all"`
      );
    }
    if (cursor) {
      return this.GET(
        `${this._apiMode}/${isTeam ? "team_" : ""}campaigns/${campaignID}/donor_leaderboard?time_type=${timeType}`,
        max,
        cursor
      );
    }
    return this.GET(
      `${this._apiMode}/${isTeam ? "team_" : ""}campaigns/${campaignID}/donor_leaderboard?time_type=${timeType}`,
      max
    );
  }
  /**
   * Gets the user_leaderboards for a Team Campaign.
   * @param campaignID
   * @param timeType
   * @param max
   * @constructor
   */
  GetTeamUserLeaderboard(campaignID, timeType = "all", max = Number.MAX_VALUE) {
    if (!["daily", "weekly", "monthly", "yearly", "ytd", "all"].includes(timeType)) {
      throw new Error(
        `tiltify-lib::GetTeamUserLeaderboard: Invalid time_type! Must be one of "daily" | "weekly" | "monthly" | "yearly" | "ytd" | "all"`
      );
    }
    return this.GET_Array(
      `public/team_campaigns/${campaignID}/user_leaderboards?time_type=${timeType}`,
      max
    );
  }
  /**
   * Lists the Donor leaderboard for the given cause and timeType
   * @param causeID
   * @param timeType
   * @param max
   * @constructor
   */
  GetCauseDonorLeaderboard(causeID, timeType = "all", max = Number.MAX_VALUE) {
    if (!["daily", "weekly", "monthly", "yearly", "ytd", "all"].includes(timeType)) {
      throw new Error(
        `tiltify-lib::GetCauseDonorLeaderboard: Invalid time_type! Must be one of "daily" | "weekly" | "monthly" | "yearly" | "ytd" | "all"`
      );
    }
    return this.GET_Array(
      `public/cause/${causeID}/donor_leaderboard?time_type=${timeType}`,
      max
    );
  }
  /**
   * Gets the user_leaderboard for the given fundraising_event id.
   * @param fundraisingEventID
   * @param count
   * @constructor
   */
  GetEventUserLeaderboard(fundraisingEventID, count = 20) {
    return this.GET_Array(
      `${this._apiMode}/fundraising_events/${fundraisingEventID}/user_leaderboard`,
      count
    );
  }
  /**
   * Get campaign's fitness goals
   * @param campaignID
   * @param isTeam
   * @param max
   * @constructor
   */
  GetCampaignFitnessGoals(campaignID, isTeam = false, max = 20) {
    return this.GET_Array(
      `public/${isTeam ? "team_" : ""}campaigns/${campaignID}/fitness_goals`,
      max
    );
  }
  /**
   * Get the top teams fitness distances for the given fundraisingEventID
   * @param fundraisingEventID
   * @param timeType
   * @param max
   * @constructor
   */
  GetEventTeamsFitnessDistanceLeaderboard(fundraisingEventID, timeType = "all", max = 20) {
    if (!["daily", "weekly", "monthly", "yearly", "ytd", "all"].includes(timeType)) {
      throw new Error(
        `tiltify-lib::GetEventTeamsFitnessDistanceLeaderboard: Invalid time_type! Must be one of "daily" | "weekly" | "monthly" | "yearly" | "ytd" | "all"`
      );
    }
    return this.GET_Array(
      `public/fundraising_events/${fundraisingEventID}/team_fitness_distance_leaderboard?time_type=${timeType}`,
      max
    );
  }
  /**
   * Get the top teams fitness times for the given fundraisingEventID
   * @param fundraisingEventID
   * @param timeType
   * @param max
   * @constructor
   */
  GetEventTeamsFitnessTimeLeaderboard(fundraisingEventID, timeType = "all", max = 20) {
    if (!["daily", "weekly", "monthly", "yearly", "ytd", "all"].includes(timeType)) {
      throw new Error(
        `tiltify-lib::GetEventTeamsFitnessTimeLeaderboard: Invalid time_type! Must be one of "daily" | "weekly" | "monthly" | "yearly" | "ytd" | "all"`
      );
    }
    return this.GET_Array(
      `public/fundraising_events/${fundraisingEventID}/team_fitness_time_leaderboard?time_type=${timeType}`,
      max
    );
  }
  /**
   * Get the top user fitness times for the given fundraisingEventID
   * @param fundraisingEventID
   * @param timeType
   * @param max
   * @constructor
   */
  GetEventUserFitnessTimeLeaderboard(fundraisingEventID, timeType = "all", max = 20) {
    if (!["daily", "weekly", "monthly", "yearly", "ytd", "all"].includes(timeType)) {
      throw new Error(
        `tiltify-lib::GetEventUserFitnessTimeLeaderboard: Invalid time_type! Must be one of "daily" | "weekly" | "monthly" | "yearly" | "ytd" | "all"`
      );
    }
    return this.GET_Array(
      `public/fundraising_events/${fundraisingEventID}/user_fitness_time_leaderboard?time_type=${timeType}`,
      max
    );
  }
  /**
   * Get the top user fitness distance for the given fundraisingEventID
   * @param fundraisingEventID
   * @param timeType
   * @param max
   * @constructor
   */
  GetEventUserFitnessDistanceLeaderboard(fundraisingEventID, timeType = "all", max = 20) {
    if (!["daily", "weekly", "monthly", "yearly", "ytd", "all"].includes(timeType)) {
      throw new Error(
        `tiltify-lib::GetEventUserFitnessDistanceLeaderboard: Invalid time_type! Must be one of "daily" | "weekly" | "monthly" | "yearly" | "ytd" | "all"`
      );
    }
    return this.GET_Array(
      `public/fundraising_events/${fundraisingEventID}/user_fitness_distance_leaderboard?time_type=${timeType}`,
      max
    );
  }
  /**
   * Returns a user for a given oauth access token
   * ONLY WORKS ON USER AUTH
   * @constructor
   */
  async GetCurrentUser() {
    if (this._authMode !== 1 /* USER */) {
      throw new Error("You are not in user auth mode!");
    }
    return (await this.GET("public/current-user")).data;
  }
  /**
   * Gets up to 3 active matching pledges for a given campaign.
   * NOTE: "Status = active" seems to also return inactive campaigns that timed out, because their completed_at field is null
   * @param campaignID
   * @constructor
   */
  async GetDonationMatches(campaignID) {
    return (await this.GET(
      `campaigns/${campaignID}/donation_matches?status=active&limit=100`
    )).data;
  }
};
__name(_Tiltify, "Tiltify");
__publicField(_Tiltify, "_instance");
var Tiltify = _Tiltify;
var tiltify = Tiltify.Instance;
export {
  TILTIFY_AUTH_MODE,
  TILTIFY_AUTH_STATUS,
  TILTIFY_FITNESS_GOAL_TYPES,
  TiltifyLibError,
  tiltify
};
//# sourceMappingURL=tiltify.js.map